module.exports = __webpack_public_path__ + "img/bdg_done.a4364c8b.svg";